import type { PaymentType } from '@core/types/imt'
import BankIcon from '@core/images/payin/bank.svg'
import BrokerIcon from '@core/images/payin/broker.svg'
import CardIcon from '@core/images/payin/card.svg'
import CashIcon from '@core/images/payin/cash.svg'
import DeliveryIcon from '@core/images/payin/delivery.svg'
import TopupIcon from '@core/images/payin/topup.svg'
import WalletIcon from '@core/images/payin/wallet.svg'

export function getPaymentIcon(type: PaymentType | (string & {}) | undefined) {
  switch (type) {
    case 'bank':
      return BankIcon
    case 'broker':
      return BrokerIcon
    case 'card':
      return CardIcon
    case 'cash':
      return CashIcon
    case 'delivery':
      return DeliveryIcon
    case 'topup':
      return TopupIcon
    case 'wallet':
      return WalletIcon
  }
  return undefined
}
